import { useEffect, useState } from "react";
import { masterApi } from "@/lib/api";

export const BLOCKED_MSG = "Your store has been deleted or deactivated. Please contact ZapBasket support.";
export const isBlocked = (e) => e?.response?.status === 403 && e?.response?.data?.detail === BLOCKED_MSG;

export const useSupportContact = () => {
  const [c, setC] = useState(null);
  useEffect(() => { masterApi.get("/support/contact").then((r) => setC(r.data)).catch(() => setC({})); }, []);
  return c;
};
